// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-wrapper {
  min-height: 640px;
  height: 700px;
  overflow: hidden;
  min-width: 0;
}

.chart-canvas {
  width: 100% !important;
  height: 100%;
  max-width: 100%;
}

.chart-empty {
  padding: 16px;
  text-align: center;
  color: #6b7280;
  font-size: 13px;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 9999px;
  background: #f3f4f6;
  color: #374151;
  font-size: 12px;
}

.preset-pill {
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}

.date-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  flex-wrap: wrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.toolbar-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.toolbar-sep {
  width: 1px;
  height: 28px;
  background: #e5e7eb;
  flex-shrink: 0;
}

.date-input {
  height: 34px;
  padding: 4px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  color: #374151;
  background: #f9fafb;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.date-input:focus {
  border-color: #3b82f6;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.preset-chip {
  padding: 5px 14px;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #374151;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.preset-chip:hover {
  border-color: #3b82f6;
  color: #1d4ed8;
}
.preset-chip.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}

.data-status-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: linear-gradient(90deg, #f0fdf4, #f0f9ff);
  border: 1px solid #bbf7d0;
  border-radius: 9999px;
  font-size: 13px;
  flex-wrap: wrap;
}

.status-sep {
  width: 1px;
  height: 16px;
  background: #a7f3d0;
  flex-shrink: 0;
}

.preset-badge {
  padding: 2px 10px;
  background: #eff6ff;
  color: #1d4ed8;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
}

.filter-row {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  transition: box-shadow 0.15s;
}
.filter-row--expanded {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.filter-row-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  flex-wrap: wrap;
}

.filter-row-toggle {
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 1;
  min-width: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-align: left;
}
.filter-row-toggle .filter-chevron {
  margin-left: 4px;
  color: #9ca3af;
  transition: color 0.15s;
}
.filter-row-toggle:hover .filter-chevron {
  color: #374151;
}

.filter-row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.filter-check {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #374151;
  -webkit-user-select: none;
          user-select: none;
}
.filter-check input[type=checkbox] {
  width: 13px;
  height: 13px;
  cursor: pointer;
}

.filter-row-body {
  padding: 12px 16px 16px;
  border-top: 1px solid #f3f4f6;
}

.evg-filter-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 0.15s, background 0.15s;
}

.evg-filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.12s;
}
.evg-filter-header:hover {
  background: rgba(0, 0, 0, 0.02);
}

.evg-filter-params {
  padding: 6px 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.evg-param-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.1s;
}
.evg-param-row:hover {
  background: #f3f4f6;
}
.evg-param-row.evg-param--active {
  background: transparent;
}

.code-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
  border-left-width: 3px;
  cursor: pointer;
  transition: opacity 0.15s, background 0.15s, box-shadow 0.15s;
}
.code-card--error {
  border-left-color: #ef4444;
}
.code-card--warning {
  border-left-color: #f59e0b;
}
.code-card--active {
  background: #fff;
  opacity: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
}
.code-card--inactive {
  opacity: 0.45;
  background: #f9fafb;
}
.code-card:hover {
  opacity: 1 !important;
  background: #fff;
}

.code-badge {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 9999px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.evg-stat-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  transition: box-shadow 0.15s;
}
.evg-stat-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.evg-stat-card--error {
  border-color: #fca5a5;
  background: #fff7f7;
}
.evg-stat-card--warn {
  border-color: #fcd34d;
  background: #fffbeb;
}

.evg-stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
}

.evg-stat-metrics {
  padding: 8px 10px 6px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.evg-stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.evg-stat-subrow {
  font-size: 10px;
  text-align: right;
  margin-top: -3px;
  margin-bottom: 2px;
}

.evg-stat-label {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: #6b7280;
}

.evg-stat-value {
  font-size: 11px;
  font-weight: 600;
  color: #111827;
  font-variant-numeric: tabular-nums;
}

.evg-stat-footer {
  display: flex;
  gap: 4px;
  padding: 5px 10px 7px;
  border-top: 1px solid #f3f4f6;
  flex-wrap: wrap;
}

.evg-count {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 9999px;
}
.evg-count--error {
  background: #fee2e2;
  color: #dc2626;
}
.evg-count--warn {
  background: #fef3c7;
  color: #d97706;
}

.chart-stats-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0 20px;
  padding: 5px 10px;
  background: rgba(248, 250, 252, 0.9);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 11px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.stat-param {
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-min {
  color: #3b82f6;
  font-weight: 600;
}

.stat-max {
  color: #ef4444;
  font-weight: 600;
}

.stat-avg {
  color: #8b5cf6;
  font-weight: 600;
}

.stat-sep {
  color: #cbd5e1;
}

@keyframes tt-fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.tt-hidden {
  display: none !important;
}

.chart-tooltip {
  position: fixed; /* viewport-level: never clipped by any parent overflow */
  z-index: 9999;
  pointer-events: none;
  background: rgba(10, 15, 28, 0.96);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 12px 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
  color: #e2e8f0;
  font-size: 12px;
  min-width: 220px;
  max-width: 560px;
  animation: tt-fade-in 120ms ease;
  transition: left 60ms ease, top 60ms ease;
}

.ct-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.ct-time {
  font-size: 13px;
  font-weight: 600;
  color: #f1f5f9;
  letter-spacing: 0.01em;
}

.ct-alarm-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 9999px;
  background: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.35);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ct-evg-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.ct-evg {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
}
.ct-evg--error {
  border-color: rgba(239, 68, 68, 0.4);
}
.ct-evg--warn {
  border-color: rgba(245, 158, 11, 0.4);
}

.ct-evg-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.ct-evg-icon {
  font-size: 14px !important;
  width: 14px !important;
  height: 14px !important;
}
.ct-evg-icon--error {
  color: #f87171;
}
.ct-evg-icon--warn {
  color: #fbbf24;
}

.ct-evg-label {
  font-size: 13px;
  font-weight: 700;
}

.ct-lamp {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 600;
}
.ct-lamp--on {
  color: #4ade80;
}
.ct-lamp--off {
  color: #f87171;
}

.ct-evg-metrics {
  display: grid;
  grid-template-columns: auto 1fr auto 1fr;
  gap: 3px 8px;
  padding: 7px 10px;
  align-items: baseline;
}

.ct-metric-label {
  font-size: 11px;
  color: #94a3b8;
  white-space: nowrap;
}

.ct-metric-value {
  font-size: 12px;
  font-weight: 700;
  color: #f1f5f9;
  font-variant-numeric: tabular-nums;
}

.ct-codes {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 0 10px 8px;
}

.ct-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}

.ct-alarm-section-header {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.ct-series-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ct-series-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ct-series-label {
  flex: 1;
  color: #94a3b8;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ct-series-value {
  font-size: 12px;
  font-weight: 700;
  color: #f1f5f9;
  font-variant-numeric: tabular-nums;
}

.filter-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 16px;
}

.fp-section {
  padding: 12px 14px;
}

.fp-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.fp-section-title {
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.fp-count {
  font-size: 10px;
  color: #9ca3af;
  background: #f3f4f6;
  padding: 0 5px;
  border-radius: 9999px;
}

.fp-action-btn {
  font-size: 10px;
  font-weight: 600;
  color: #6b7280;
  background: #f3f4f6;
  border: none;
  border-radius: 4px;
  padding: 2px 6px;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.fp-action-btn:hover {
  background: #e5e7eb;
  color: #111827;
}

.fp-divider {
  height: 1px;
  background: #f3f4f6;
  margin: 0;
}

.fp-evg-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fp-evg-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.fp-evg-chip {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  width: 72px;
  transition: background 0.12s, border-color 0.12s;
}
.fp-evg-chip:hover {
  filter: brightness(0.95);
}

.fp-evg-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.fp-param-pills {
  display: flex;
  gap: 3px;
}

.fp-param-pill {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 5px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.12s;
}
.fp-param-pill--on {
  background: var(--evg-color, #3b82f6);
  border-color: var(--evg-color, #3b82f6);
  color: #fff;
}
.fp-param-pill:hover {
  border-color: #9ca3af;
}

.fp-show-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  cursor: pointer;
}

.fp-code-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.fp-code-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #f3f4f6;
  border-left: 3px solid var(--code-color, #ef4444);
  background: #f9fafb;
  cursor: pointer;
  text-align: left;
  transition: opacity 0.15s, background 0.15s;
  opacity: 0.4;
  width: 100%;
}
.fp-code-pill--on {
  opacity: 1;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}
.fp-code-pill:hover {
  opacity: 1 !important;
  background: #fff;
}

.fp-code-num {
  font-size: 10px;
  font-weight: 700;
  color: var(--code-color, #ef4444);
  flex-shrink: 0;
  min-width: 28px;
}

.fp-code-name {
  font-size: 10px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-quick-btn {
  font-size: 11px;
  padding: 3px 9px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
}
.lt-quick-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}
.lt-quick-btn.lt-quick-all {
  border-color: #6366f1;
  color: #6366f1;
}
.lt-quick-btn.lt-quick-all:hover {
  background: #eef2ff;
}`, "",{"version":3,"sources":["webpack://./src/app/features/historical-data/historical-data.scss"],"names":[],"mappings":"AACA;EACC,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAAD;;AAGA;EACC,sBAAA;EACA,YAAA;EACA,eAAA;AAAD;;AAGA;EACC,aAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAAD;;AAIA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADD;;AAIA;EACC,mBAAA;EACA,cAAA;EACA,gBAAA;AADD;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yCAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,gDAAA;AAFF;AAIE;EACE,qBAAA;EACA,gBAAA;EACA,6CAAA;AAFJ;;AAOA;EACE,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;AAJF;AAME;EACE,qBAAA;EACA,cAAA;AAJJ;AAOE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,6CAAA;AALJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,oDAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAPF;;AAUA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAPF;;AAUA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAPF;;AAWA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,4BAAA;AARF;AAUE;EAAc,yCAAA;AAPhB;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AAPF;AASE;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;AAPJ;AAUE;EAA0B,cAAA;AAP5B;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAPJ;;AAWA;EACE,uBAAA;EACA,6BAAA;AARF;;AAYA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gDAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;AATF;AAWE;EAAU,+BAAA;AARZ;;AAWA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AARF;AAUE;EAAU,mBAAA;AAPZ;AAQE;EAAsB,uBAAA;AALxB;;AASA;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,6DAAA;AAND;AAQC;EAAY,0BAAA;AALb;AAMC;EAAa,0BAAA;AAHd;AAKC;EACC,gBAAA;EACA,UAAA;EACA,yCAAA;AAHF;AAMC;EACC,aAAA;EACA,mBAAA;AAJF;AAOC;EAAU,qBAAA;EAAuB,gBAAA;AAHlC;;AAMA;EACC,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAHD;;AAOA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAJF;AAME;EAAU,yCAAA;AAHZ;AAKE;EACE,qBAAA;EACA,mBAAA;AAHJ;AAME;EACE,qBAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gCAAA;AALF;;AAQA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AALF;;AAQA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AALF;;AAQA;EACE,aAAA;EACA,QAAA;EACA,qBAAA;EACA,6BAAA;EACA,eAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AALF;AAOE;EACE,mBAAA;EACA,cAAA;AALJ;AAQE;EACE,mBAAA;EACA,cAAA;AANJ;;AAWA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AARF;;AAWA;EAAc,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAJ3E;;AAKA;EAAc,cAAA;EAAgB,gBAAA;AAA9B;;AACA;EAAc,cAAA;EAAgB,gBAAA;AAI9B;;AAHA;EAAc,cAAA;EAAgB,gBAAA;AAQ9B;;AAPA;EAAc,cAAA;AAWd;;AARA;EACE;IAAO,UAAA;IAAY,0BAAA;EAanB;EAZA;IAAO,UAAA;IAAY,wBAAA;EAgBnB;AACF;AAdA;EAAa,wBAAA;AAiBb;;AAfA;EACE,eAAA,EAAA,yDAAA;EACA,aAAA;EACA,oBAAA;EACA,kCAAA;EACA,0BAAA;EACA,kCAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yCAAA;AAkBF;;AAfA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iDAAA;AAkBF;;AAfA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAkBF;;AAfA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mCAAA;EACA,cAAA;EACA,yCAAA;EACA,sBAAA;EACA,yBAAA;AAkBF;;AAdA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AAiBF;;AAdA;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;AAiBF;AAfE;EAAW,oCAAA;AAkBb;AAjBE;EAAW,qCAAA;AAoBb;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kDAAA;AAoBF;;AAjBA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;AAoBF;AAlBE;EAAW,cAAA;AAqBb;AApBE;EAAW,cAAA;AAuBb;;AApBA;EACE,eAAA;EACA,gBAAA;AAuBF;;AApBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAuBF;AArBE;EAAS,cAAA;AAwBX;AAvBE;EAAS,cAAA;AA0BX;;AAtBA;EACE,aAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;AAyBF;;AAtBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAyBF;;AAtBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAyBF;;AArBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAwBF;;AArBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AAwBF;;AApBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AAuBF;;AAnBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAsBF;;AAnBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAsBF;;AAnBA;EACE,OAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAsBF;;AAnBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAsBF;;AAlBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,gBAAA;EACA,SAAA;AAqBF;;AAlBA;EACE,kBAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAqBF;;AAlBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAqBF;;AAlBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AAqBF;;AAlBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AAqBF;AAnBE;EAAU,mBAAA;EAAqB,cAAA;AAuBjC;;AApBA;EACE,WAAA;EACA,mBAAA;EACA,SAAA;AAuBF;;AAnBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAsBF;;AAnBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAsBF;;AAnBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,gDAAA;AAsBF;AApBE;EAAU,wBAAA;AAuBZ;;AApBA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAuBF;;AApBA;EACE,aAAA;EACA,QAAA;AAuBF;;AApBA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAuBF;AArBE;EACE,qCAAA;EACA,uCAAA;EACA,WAAA;AAuBJ;AApBE;EAAU,qBAAA;AAuBZ;;AAnBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAsBF;;AAnBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAsBF;;AAnBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iDAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;AAsBF;AApBE;EACE,UAAA;EACA,gBAAA;EACA,yCAAA;AAsBJ;AAnBE;EAAU,qBAAA;EAAuB,gBAAA;AAuBnC;;AApBA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;EACA,eAAA;AAuBF;;AApBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAuBF;;AAnBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6DAAA;EACA,mBAAA;AAsBF;AApBE;EACE,mBAAA;EACA,qBAAA;AAsBJ;AAnBE;EACE,qBAAA;EACA,cAAA;AAqBJ;AAnBI;EAAU,mBAAA;AAsBd","sourcesContent":["// ── Chart ──────────────────────────────────────────────────────────────────\n.chart-wrapper {\n\tmin-height: 640px;\n\theight: 700px;\n\toverflow: hidden;\n\tmin-width: 0;\n}\n\n.chart-canvas {\n\twidth: 100% !important;\n\theight: 100%;\n\tmax-width: 100%;\n}\n\n.chart-empty {\n\tpadding: 16px;\n\ttext-align: center;\n\tcolor: #6b7280;\n\tfont-size: 13px;\n}\n\n// ── Pill badges in chart footer ────────────────────────────────────────────\n.pill {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tpadding: 4px 10px;\n\tborder-radius: 9999px;\n\tbackground: #f3f4f6;\n\tcolor: #374151;\n\tfont-size: 12px;\n}\n\n.preset-pill {\n\tbackground: #eff6ff;\n\tcolor: #1d4ed8;\n\tfont-weight: 600;\n}\n\n// ── Date Toolbar ───────────────────────────────────────────────────────────\n.date-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 16px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  flex-wrap: wrap;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.toolbar-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.toolbar-sep {\n  width: 1px;\n  height: 28px;\n  background: #e5e7eb;\n  flex-shrink: 0;\n}\n\n.date-input {\n  height: 34px;\n  padding: 4px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #374151;\n  background: #f9fafb;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n\n  &:focus {\n    border-color: #3b82f6;\n    background: #fff;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  }\n}\n\n// ── Preset Chips ───────────────────────────────────────────────────────────\n.preset-chip {\n  padding: 5px 14px;\n  border-radius: 9999px;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n\n  &:hover {\n    border-color: #3b82f6;\n    color: #1d4ed8;\n  }\n\n  &.active {\n    background: #2563eb;\n    border-color: #2563eb;\n    color: #fff;\n    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);\n  }\n}\n\n// ── Data Status Strip ──────────────────────────────────────────────────────\n.data-status-strip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 16px;\n  background: linear-gradient(90deg, #f0fdf4, #f0f9ff);\n  border: 1px solid #bbf7d0;\n  border-radius: 9999px;\n  font-size: 13px;\n  flex-wrap: wrap;\n}\n\n.status-sep {\n  width: 1px;\n  height: 16px;\n  background: #a7f3d0;\n  flex-shrink: 0;\n}\n\n.preset-badge {\n  padding: 2px 10px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n// ── Filter rows (Error Codes / Warning Codes — collapsible) ────────────────\n.filter-row {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.04);\n  overflow: hidden;\n  transition: box-shadow 0.15s;\n\n  &--expanded { box-shadow: 0 2px 8px rgba(0,0,0,0.08); }\n}\n\n.filter-row-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  flex-wrap: wrap;\n}\n\n.filter-row-toggle {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex: 1;\n  min-width: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  text-align: left;\n\n  .filter-chevron {\n    margin-left: 4px;\n    color: #9ca3af;\n    transition: color 0.15s;\n  }\n\n  &:hover .filter-chevron { color: #374151; }\n}\n\n.filter-row-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.filter-check {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #374151;\n  user-select: none;\n\n  input[type='checkbox'] {\n    width: 13px;\n    height: 13px;\n    cursor: pointer;\n  }\n}\n\n.filter-row-body {\n  padding: 12px 16px 16px;\n  border-top: 1px solid #f3f4f6;\n}\n\n// ── EVG Filter card ─────────────────────────────────────────────────────────\n.evg-filter-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.evg-filter-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border-bottom: 1px solid #f3f4f6;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.12s;\n\n  &:hover { background: rgba(0,0,0,0.02); }\n}\n\n.evg-filter-params {\n  padding: 6px 10px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.evg-param-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 4px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.1s;\n\n  &:hover { background: #f3f4f6; }\n  &.evg-param--active { background: transparent; }\n}\n\n// ── Code Toggle Cards (Error & Warning) ────────────────────────────────────\n.code-card {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 10px;\n\tpadding: 8px 12px;\n\tborder-radius: 8px;\n\tborder: 1px solid #f3f4f6;\n\tborder-left-width: 3px;\n\tcursor: pointer;\n\ttransition: opacity 0.15s, background 0.15s, box-shadow 0.15s;\n\n\t&--error  { border-left-color: #ef4444; }\n\t&--warning { border-left-color: #f59e0b; }\n\n\t&--active {\n\t\tbackground: #fff;\n\t\topacity: 1;\n\t\tbox-shadow: 0 1px 3px rgba(0,0,0,0.07);\n\t}\n\n\t&--inactive {\n\t\topacity: 0.45;\n\t\tbackground: #f9fafb;\n\t}\n\n\t&:hover { opacity: 1 !important; background: #fff; }\n}\n\n.code-badge {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tpadding: 1px 7px;\n\tborder-radius: 9999px;\n\tcolor: #fff;\n\tfont-size: 11px;\n\tfont-weight: 700;\n\tflex-shrink: 0;\n}\n\n// ── EVG Performance Summary — stat cards ───────────────────────────────────\n.evg-stat-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n  transition: box-shadow 0.15s;\n\n  &:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.08); }\n\n  &--error {\n    border-color: #fca5a5;\n    background: #fff7f7;\n  }\n\n  &--warn {\n    border-color: #fcd34d;\n    background: #fffbeb;\n  }\n}\n\n.evg-stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.evg-stat-metrics {\n  padding: 8px 10px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.evg-stat-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n}\n\n.evg-stat-subrow {\n  font-size: 10px;\n  text-align: right;\n  margin-top: -3px;\n  margin-bottom: 2px;\n}\n\n.evg-stat-label {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.evg-stat-value {\n  font-size: 11px;\n  font-weight: 600;\n  color: #111827;\n  font-variant-numeric: tabular-nums;\n}\n\n.evg-stat-footer {\n  display: flex;\n  gap: 4px;\n  padding: 5px 10px 7px;\n  border-top: 1px solid #f3f4f6;\n  flex-wrap: wrap;\n}\n\n.evg-count {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 7px;\n  border-radius: 9999px;\n\n  &--error {\n    background: #fee2e2;\n    color: #dc2626;\n  }\n\n  &--warn {\n    background: #fef3c7;\n    color: #d97706;\n  }\n}\n\n// ── Stats Bar ────────────────────────────────────────────────────────────────\n.chart-stats-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 20px;\n  padding: 5px 10px;\n  background: rgba(248, 250, 252, 0.9);\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 11px;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.stat-param { font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; }\n.stat-min   { color: #3b82f6; font-weight: 600; }\n.stat-max   { color: #ef4444; font-weight: 600; }\n.stat-avg   { color: #8b5cf6; font-weight: 600; }\n.stat-sep   { color: #cbd5e1; }\n\n// ── Custom Chart Tooltip ─────────────────────────────────────────────────────\n@keyframes tt-fade-in {\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.tt-hidden { display: none !important; }\n\n.chart-tooltip {\n  position: fixed;   /* viewport-level: never clipped by any parent overflow */\n  z-index: 9999;\n  pointer-events: none;\n  background: rgba(10, 15, 28, 0.96);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 14px;\n  padding: 12px 14px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\n  color: #e2e8f0;\n  font-size: 12px;\n  min-width: 220px;\n  max-width: 560px;\n  animation: tt-fade-in 120ms ease;\n  transition: left 60ms ease, top 60ms ease;\n}\n\n.ct-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.10);\n}\n\n.ct-time {\n  font-size: 13px;\n  font-weight: 600;\n  color: #f1f5f9;\n  letter-spacing: 0.01em;\n}\n\n.ct-alarm-badge {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  background: rgba(239, 68, 68, 0.18);\n  color: #fca5a5;\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n// ── EVG grid — 2 columns like React design\n.ct-evg-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.ct-evg {\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 10px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.04);\n\n  &--error { border-color: rgba(239, 68, 68, 0.40); }\n  &--warn  { border-color: rgba(245, 158, 11, 0.40); }\n}\n\n.ct-evg-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.ct-evg-icon {\n  font-size: 14px !important;\n  width: 14px !important;\n  height: 14px !important;\n\n  &--error { color: #f87171; }\n  &--warn  { color: #fbbf24; }\n}\n\n.ct-evg-label {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.ct-lamp {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 10px;\n  font-weight: 600;\n\n  &--on  { color: #4ade80; }\n  &--off { color: #f87171; }\n}\n\n// ── Metrics — 2×2 label-value grid\n.ct-evg-metrics {\n  display: grid;\n  grid-template-columns: auto 1fr auto 1fr;\n  gap: 3px 8px;\n  padding: 7px 10px;\n  align-items: baseline;\n}\n\n.ct-metric-label {\n  font-size: 11px;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.ct-metric-value {\n  font-size: 12px;\n  font-weight: 700;\n  color: #f1f5f9;\n  font-variant-numeric: tabular-nums;\n}\n\n// ── Code pills\n.ct-codes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 0 10px 8px;\n}\n\n.ct-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 0.02em;\n}\n\n// ── Alarm section divider inside tooltip\n.ct-alarm-section-header {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n// ── Hovered series row (always-visible at top of tooltip)\n.ct-series-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ct-series-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.ct-series-label {\n  flex: 1;\n  color: #94a3b8;\n  font-size: 11px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ct-series-value {\n  font-size: 12px;\n  font-weight: 700;\n  color: #f1f5f9;\n  font-variant-numeric: tabular-nums;\n}\n\n// ── Filter Panel (left sidebar) ───────────────────────────────────────────────\n.filter-panel {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n  position: sticky;\n  top: 16px;\n}\n\n.fp-section {\n  padding: 12px 14px;\n}\n\n.fp-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.fp-section-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.fp-count {\n  font-size: 10px;\n  color: #9ca3af;\n  background: #f3f4f6;\n  padding: 0 5px;\n  border-radius: 9999px;\n}\n\n.fp-action-btn {\n  font-size: 10px;\n  font-weight: 600;\n  color: #6b7280;\n  background: #f3f4f6;\n  border: none;\n  border-radius: 4px;\n  padding: 2px 6px;\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s;\n\n  &:hover { background: #e5e7eb; color: #111827; }\n}\n\n.fp-divider {\n  height: 1px;\n  background: #f3f4f6;\n  margin: 0;\n}\n\n// ── EVG series rows ────────────────────────────────────────────────────────────\n.fp-evg-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fp-evg-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.fp-evg-chip {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 8px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background: transparent;\n  cursor: pointer;\n  flex-shrink: 0;\n  width: 72px;\n  transition: background 0.12s, border-color 0.12s;\n\n  &:hover { filter: brightness(0.95); }\n}\n\n.fp-evg-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.fp-param-pills {\n  display: flex;\n  gap: 3px;\n}\n\n.fp-param-pill {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 5px;\n  border-radius: 4px;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.12s;\n\n  &--on {\n    background: var(--evg-color, #3b82f6);\n    border-color: var(--evg-color, #3b82f6);\n    color: #fff;\n  }\n\n  &:hover { border-color: #9ca3af; }\n}\n\n// ── Error / Warning code pills ─────────────────────────────────────────────────\n.fp-show-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n\n.fp-code-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.fp-code-pill {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: 1px solid #f3f4f6;\n  border-left: 3px solid var(--code-color, #ef4444);\n  background: #f9fafb;\n  cursor: pointer;\n  text-align: left;\n  transition: opacity 0.15s, background 0.15s;\n  opacity: 0.4;\n  width: 100%;\n\n  &--on {\n    opacity: 1;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.06);\n  }\n\n  &:hover { opacity: 1 !important; background: #fff; }\n}\n\n.fp-code-num {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--code-color, #ef4444);\n  flex-shrink: 0;\n  min-width: 28px;\n}\n\n.fp-code-name {\n  font-size: 10px;\n  color: #6b7280;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// ── Quick parameter shortcuts ─────────────────────────────────────────────────\n.lt-quick-btn {\n  font-size: 11px;\n  padding: 3px 9px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #374151;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n  white-space: nowrap;\n\n  &:hover {\n    background: #f3f4f6;\n    border-color: #d1d5db;\n  }\n\n  &.lt-quick-all {\n    border-color: #6366f1;\n    color: #6366f1;\n\n    &:hover { background: #eef2ff; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
